import { Query, getResult, mergeFilter, setPaginate, setSearch, setSort } from '@btime/query-monad'
import { generateContext, useCleanFilterForRequest, useListReducer, useSearch, useSort } from '@btime/react-contexts'
import { useApi } from '@btime/react-api'
import { useEffectAfterMount } from '@btime/react-hooks'
import React, { useContext } from 'react'

import { formatEntitiesFilters } from './formatFilters'
import { useLoader } from '../../../../utils/loader/loader.hook'
import LoadMoreOnBottom from '../../../../components/helpers/LoadMoreOnBottom'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useLogs = () => useContext(StateContext) || {}
export const useLogsList = () => useContext(StateContext).list
export const useLogsActions = () => useContext(ActionsContext)

const LogsListLoader = ({ children, uncontrolledChildren }) => {
  const [state, { setList, setPage, mergeList, addPage, removeItemById, mergeItemById }] = useListReducer()
  const listLogsEndpoint = useApi('listLogsEndpoint')

  const filter = useCleanFilterForRequest()
  const search = useSearch()
  const sort = useSort()

  const callApi = stateControl => {
    const { clearState, setEmpty, setErrorMessage, stopAllLoadings } = stateControl

    const isMerge = state.page > 1
    const storeData = isMerge ? mergeList : setList
    if (!isMerge) clearState()

    Query({ ignore401: true })
      .map(setPaginate(state.page, 20))
      .map(setSort({ field: 'happenedAt', type: 'DESC' }))
      .map(setSort(sort))
      .map(mergeFilter(formatEntitiesFilters(filter)))
      .map(setSearch(search))
      .map(listLogsEndpoint)

      .chainThen(queryResponse => {
        queryResponse
          .map(getResult) //
          .jump(storeData)
          .map(stopAllLoadings)
      })
      .catch(e => setErrorMessage(e.message))
  }

  useEffectAfterMount(() => setPage(1), [search, sort, filter])
  const { render } = useLoader(callApi, [state.reload])

  const forceReload = () => setPage(1)
  const sharedActions = { removeItemById, forceReload }

  return (
    <Provider state={state} actions={sharedActions}>
      {render || <LoadMoreOnBottom loadMoreAction={addPage} canLoadMore={state.canLoadMore} children={children} />}
      {uncontrolledChildren}
    </Provider>
  )
}

export default LogsListLoader
